// polyfills
import 'core-js/fn/array/find';
import 'core-js/fn/array/includes';

// react
import React from 'react';
import ReactDOM from 'react-dom';

// redux libraries
import { Provider } from 'react-redux';
import { createStore, compose, combineReducers, applyMiddleware } from 'redux';
import thunk from 'redux-thunk';

import { Fabric } from 'office-ui-fabric-react/lib/Fabric';

// react component(s)
import App from './App';

import registerServiceWorker from './registerServiceWorker';

//styles
import './styles/app.scss';

// Register icons and pull the fonts from the default SharePoint cdn:
import { initializeIcons } from '@uifabric/icons';

//reducers
import modal from './store/reducers/modal';
import multi from './store/reducers/multi';
import nav from './store/reducers/nav';
import por from './store/reducers/por';
import auth from './store/reducers/auth';
import help from './store/reducers/help';


initializeIcons();


// apply reduc dev tools
const composeEnhancers = window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

// combine reducers
const rootReducer = combineReducers({
  modal,
  multi,
  nav,
  por,
  auth,
  help
});

// create store
const store = createStore(
  rootReducer, 
  composeEnhancers(applyMiddleware(thunk))
);

ReactDOM.render(
  <Fabric>
    <Provider store={ store }>
      <App />
    </Provider>
  </Fabric>, 
  document.getElementById('root')
);
registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js